<!-- Events -->
<!-- itemCreated -->

<template>
  <v-container fluid>
    <v-row>
      <v-data-table
        :headers="headers"
        :items="items"
        :items-per-page="5"
        item-key="tkt_id"
        height="350px"
      >
        <template v-slot:item.tkt_date_entered="{ item }">
          {{ formatDate(item.tkt_date_entered) }}
        </template>

      </v-data-table>
    </v-row>
  </v-container>
</template>

<script>
  // Utilities
  import moment from '@/assets/js/moment.min'
  import { mapActions, mapGetters } from 'vuex'
  import {
    ACCT_GET_ACCOUNT_TICKETS,
  } from '@/store/actions.types'
  import basicMixin from '../../mixins/basic'
  export default {
    name: 'PowAccountTickets',
    mixins: [basicMixin],

    inheritAttrs: false,

    props: {
      item: {
        type: Object,
        default: () => ({
          name: undefined,
          invoice: undefined,
          due_date: undefined,
          total: undefined,
          paid: undefined,
          is_paid: undefined,
          details: undefined,
        }),
      },
    },
    data: function () {
      return {
        currentObject: {},
        snapshotObject: {},
        formMode: '',
        formErrors: [],
        overlayAbsolute: true,
        overlayDisplay: false,
        headers: [
          {
            text: 'Date',
            align: 'start',
            sortable: false,
            value: 'tkt_date_entered',
          },
          { text: 'Problem', value: 'tkt_problem' },
          { text: 'Status', value: 'status' },
        ],
      }
    },

    computed: {
      ...mapGetters({
        items: 'acctSelectedAccountTickets',
        selectedAccount: 'acctSelectedAccount',
      }),
    },
    async created () {
      // this.init()
    },
    async mounted () {
      this.init()
    },
    methods: {
      ...mapActions({
        getTickets: ACCT_GET_ACCOUNT_TICKETS,
      }),
      init () {
        console.log(`Initializing ${name} setting values!`, this.item)
        this.getTickets({ rowkey: this.selectedAccount.rowkey })
        this.formMode = 'read'
        // console.log(val)
        // this.currentObject = { ...this.item }
        // this.snapshotObject = { ...this.item }
      },
      resetForm () {
        this.overlayDisplay = false
        this.currentObject = { ...this.snapshotObject }
        this.formErrors = []
      },
      formatDate (value, format) {
        if (!format) {
          format = 'M/D/YYYY'
        }
        return moment(value).format(format)
      },
    },

  }
</script>

<style>
</style>
